module.exports = __webpack_public_path__ + "img/BG4-text.699ba309.png";